import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import { WebStorageService, Scope } from '@mmortgage/common-utility';
import { UserIdleService } from 'angular-user-idle';
import { formatDate, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { FbPaidPixelService } from 'src/app/service/fbpaid-pixel.service';
import { GAdsPaidPixelService } from 'src/app/service/gads-paid-pixels.service';
import { DvtagPaidPixelService } from 'src/app/service/dvgtag-paid-pixels.service';
import { environment } from 'src/environments/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import * as CONSTANTS from '../../constants';
import { encodeConst } from 'src/app/constants';
import { AdobeAnalyticsDigitalDataService } from 'src/app/service/adobe-analytics-digitaldata.service';
import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
registerLocaleData(localeFr, 'fr');
declare var bootstrap: any;
@Component({
  selector: 'prequalification-results',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.less'],
  providers: [FrameworkUtilityComponent]
})

export class SummaryComponent implements OnInit,OnDestroy {
  @ViewChildren('dot', { read: ElementRef }) dots!: QueryList<ElementRef>;
  @ViewChild('popContent1') content: any;
  currentLang: string;
  popOverType: string = '';
  coApplicantSelectionObj: any = {};
  preQualObj: any;
  applicantName: any;
  isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  $: any;
  modalRef: NgbModalRef;
  indexNumber: number;
  clicked: boolean = false;
  rateType = "";
  productName: string = '';
  percentage: number;
  loader: boolean = false;
  newPercentage: string;
  mortgageAmounts = [];
  amortizationPeriods = [];
  timerCompleted = false;
  fixedRate = 'Fixed';
  variableRate = 'Variable';
  fixedCode = 'F';
  currLangEn = 'en';
  currLangFr = 'fr';
  prequalType = 'P';
  switchType = 'S';

  mappedPaymentFrequency = [
    { code: "W", en: "Weekly", fr: "Chaque semaine" },
    { code: "B", en: "Bi-Weekly", fr: "Toutes les deux semaines" },
    { code: "M", en: "Monthly", fr: "Chaque mois" },
    {
      code: "S", en: "Semi-Monthly", fr: "Deux fois par mois" },
  ]
  prequalData: any;
  downPayment: any;
  mortgageAmount: any;
  netMortgageAmount: any;
  estimatedPayments: any;
  currentRoutePath: any;
  productFlow: any;
  selectedAmortization: any;
  selectedFrequency: any;
  estimatedPaymentsSwitch: any;
  sampleData: any;
  count: number = 0;
  percentageValues = [];
  timestamp: string;
  prdDetails: any;
  amortizationChangeValues: any;
  formatted: string;
  month_en = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  month_fr = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet:", "août:", "septembre", "octobre", "novembre", "décembre"];
  insureFee: any;
  rate: any = "";
  mortgage_principal: any;
  leftPosition: number[];
  index: any;
  zindex: number;
  thumbColor: boolean;
  switchDiscount: string;
  paymentFrequencys = [];
  selectedAmortizationPopUp: string = '';
  clientRate: any;
  percentageLength: number;
  switch_rate_expires: any;
  amortlower: string = "25 Years";
  amortHigher: string = "25 années";
  sliderWidth: string = "582px";
  sliderCircleWidth: string = "15px";
  sliderCircleHeight: string = "15px";
  sliderHeight: string = "5px";
  discount: string = "";
  defaultInd: any;
  advisorNumber: string = '';
  msaUser: boolean = false;
  msaPrefix: string = '1';
  unSubMaAssigned: Subscription;
  isReferralMaPresent: boolean=false;
  referral: boolean=false;

  constructor(private util: UtilService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private _router: Router,
    private i18nService: I18nService,
    private formUtiObj: FrameworkUtilityComponent,
    private storageService: WebStorageService,
    private breakpointObserver: BreakpointObserver,
    private fpService: FbPaidPixelService,
    private dvService: DvtagPaidPixelService,
    private gadsService: GAdsPaidPixelService,
    private adobeAnalyticsData: AdobeAnalyticsDigitalDataService) {
    this.util.isSummaryPage.next(true);
    this.util.isSidebarVisible.next(false);
    this.preQualObj = this.util.getSessionStorage();
    this._activatedRoute.queryParams.subscribe(params => {
      if (this.util.getReferral(params)) {
        this.referral = true;
      }
    });

  }
  ngOnDestroy() {
    if (this.unSubMaAssigned) {
      this.unSubMaAssigned.unsubscribe();
    }
  }
  ngOnInit(): void {
    this.setSubscribe();
    this.util.CLOSE_WINDOW_POPUP.next(false);
    this.zindex = 3;
    this.preQualObj.status = CONSTANTS.applicationConstants.pendingContact;
    this.applicantName = this.util.getApplicantNames();
    this.currentLang = this.i18nService.getCurrentLang();
    if (this.preQualObj?.madvsior?.userRole == CONSTANTS.userRoles.MSA) {
      this.msaUser = true;
    }
    if (this.msaUser&&this.preQualObj?.madvsior?.phone_number) {
      if (this.preQualObj.madvsior?.ext) {
        this.advisorNumber = this.msaPrefix+this.preQualObj.madvsior.phone_number + this.preQualObj.madvsior.ext;
      }
      else {
        this.advisorNumber = this.msaPrefix+this.preQualObj.madvsior.phone_number;
      }
    }
    else { 
        this.advisorNumber = this.preQualObj.madvsior.phone_number;
    }

    if (this.preQualObj.flow_type == this.prequalType) {
      this.defaultInd = this.preQualObj.prequal_slider.findIndex((obj) => obj.sliderHomePurchasePrice == this.preQualObj.preQualify_purchase_price) + 1;
      this.breakpointObserver
        .observe([Breakpoints.XSmall])
        .pipe(map(result => result.matches))
        .subscribe(matches => {
          if (matches) {
            this.sliderWidth = (36 * (this.preQualObj.prequal_slider.length - 1)) + 9 + "px";
            this.sliderCircleHeight = "9px";
            this.sliderCircleWidth = "9px";
            this.sliderHeight = "3px";
            this.leftPosition = Array.from({ length: this.preQualObj.prequal_slider.length }, (_, i) => (i * 36))

          } else {
            this.sliderWidth = (82 * (this.preQualObj.prequal_slider.length - 1)) + 15 + "px";
            this.sliderCircleHeight = "15px";
            this.sliderCircleWidth = "15px";
            this.sliderHeight = "5px";
            this.leftPosition = Array.from({ length: this.preQualObj.prequal_slider.length }, (_, i) => (i * 82))

          }
        });
      this.preQualInitialisation();
    }

    if (this.preQualObj.flow_type == this.switchType) {
      this.preQualObj.preQualify_mortgage_amount = this.preQualObj?.switchReqAmnt;
      this.prdDetails = JSON.parse(sessionStorage.getItem("prdDetails"));
      this.rateType = this.prdDetails.productDetails.metaData.rateType == this.fixedCode ? this.fixedRate : this.variableRate;
      this.productName = (this.currentLang == this.currLangEn) ? this.prdDetails.productDetails.metaData.longName[0].name : (this.currentLang == this.currLangFr) ? this.prdDetails.productDetails.metaData.longName[1].name : '';
      this.clientRate = this.preQualObj.switch_interest_rate.rate.split("%")[0];
      if (this.preQualObj.switch_interest_rate.discount) {
        this.discount = this.preQualObj.switch_interest_rate.discount.split("%")[0];
      }
      this.paymentFrequencys = (this.currentLang == this.currLangEn) ? ["Weekly", "Bi-Weekly", "Monthly", "Semi-Monthly"] : (this.currentLang == this.currLangFr) ? ["Chaque semaine", "Toutes les deux semaines", "Chaque mois", "Deux fois par mois"] : [];
      this.getDate();
    }

    this.sessionExpiryinit();
    this.checkMaIsAvailable();
  }
  setSubscribe() {
    this.unSubMaAssigned = this.util.IS_MA_ASSIGNED.subscribe(retObj => {
      if (retObj.setObj) {
        if (retObj.maModelObj != null) {
          this.isReferralMaPresent = true;
        }
      }
    })
  }
  checkMaIsAvailable() {
    let maDetail: any = this.util.getSessionStorageGeneric('maReferralLink');
    if (maDetail != undefined) {
      this.isReferralMaPresent = maDetail.isReferralMaPresent;
    }
  }
  preQualInitialisation() {
    this.mortgageAmounts = this.preQualObj.prequal_slider;
    this.indexNumber = this.defaultInd - 1;
    this.downPayment = this.mortgageAmounts[this.indexNumber].sliderDownpayment;
    this.mortgageAmount =this.mortgageAmounts[this.indexNumber].sliderTotalMtgAmt;
    this.netMortgageAmount = this.mortgageAmounts[this.indexNumber].sliderNetMtgAmt;
    this.insureFee = this.mortgageAmounts[this.indexNumber].sliderInsurerFee;
    this.mortgage_principal = this.mortgageAmounts[this.indexNumber].sliderNetMtgAmt;
    this.estimatedPayments =this.mortgageAmounts[this.indexNumber].sliderPaymentAmt;
    const index = this.preQualObj.prequal_slider.findIndex(sliderValue => this.downPayment == sliderValue.sliderDownpayment);
    if (index >= 0) {
      this.preQualObj.prequal_slider[index].sliderStatus = true;
      this.preQualObj.prequal_slider[index].updatedTime = "";
    }
     this.util.setSessionStorage(this.preQualObj);
    this.saveJson(this.preQualObj);
    if (this.preQualObj?.prequal_rate != undefined && this.preQualObj?.prequal_rate != null) {
      this.rate = this.preQualObj?.prequal_rate;
    }
  }
  sessionExpiryinit() {
    if (JSON.parse(sessionStorage.getItem("startTimer for summaryPage")) == true) {
      if (this.preQualObj.flow_type == this.switchType) {
        this.submitWcall();
      }
      this.amortizationPeriods = Array.from({ length: 28 }, (_, i) => i + 3 + ((this.currentLang == "en") ? " Years" : (this.currentLang == "fr") ? " années" : ""));

      if (this.isIos) {
        try {
          document.getElementById("btnttltip").setAttribute('aria-expanded', 'false');
        }
        catch (e) {

        }
      }
      var env = environment.env;
      // to load paid pixels only for production
      if (env == "prod") {

        if (document.getElementById("dvgtag")) {
          document.getElementById("dvgtag").remove();
        }
        if (document.getElementById("fb_noscript")) {
          document.getElementById("fb_noscript").remove();
        }
        if (document.getElementById("dc360")) {
          document.getElementById("dc360").remove();
        }
        if (document.getElementById("dvgtag_pixel")) {
          document.getElementById("dvgtag_pixel").remove();
        }
        if (document.getElementById("gads")) {
          document.getElementById("gads").remove();
        }
        if (document.getElementById("gtag_init")) {
          document.getElementById("gtag_init").remove();
        }
        if (document.getElementById("gads-conversion")) {
          document.getElementById("gads-conversion").remove();
        }

        //load the fb pixel
        this.fpService.load('end')
        //load dv 360 paid pixel
        if (!document.getElementById("dvgtag")) {
          this.dvService.load('end')
        }
        //load google adds pixel
        if (!document.getElementById("gads")) {
          this.gadsService.load('end')
        }
      }

      this.formUtiObj.InitValues();
      if (!this.util.getSessionStorage()) {
        this._router.navigate(['../home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
      let transactionFlag = atob(this.storageService.get("transactionid", Scope.session));

      this.setTimer();


    }
    else {
      this.timerCompleted = true;
      if (this.preQualObj.flow_type == this.prequalType) {
        this.indexNumber = this.preQualObj.prequal_slider.findIndex(obj => obj.sliderStatus == true)
        const selected = this.preQualObj.prequal_slider.find(obj => obj.sliderStatus == true);
        this.downPayment = selected.sliderDownpayment;
        this.mortgageAmount = selected.sliderTotalMtgAmt;
        this.netMortgageAmount = selected.sliderNetMtgAmt;
        this.insureFee = selected.sliderInsurerFee;
        this.mortgage_principal = selected.sliderNetMtgAmt;
        this.estimatedPayments = selected.sliderPaymentAmt;
      }
      else if (this.preQualObj.flow_type == this.switchType) {
        this.selectedAmortization = this.preQualObj.amortization_payments.selectedAmortization + " Years";
        this.selectedFrequency = this.preQualObj.amortization_payments.selectedFrequency;
        this.estimatedPaymentsSwitch = this.preQualObj.amortization_payments.estimatedPaymentsSwitch;
        this.selectedAmortizationPopUp = this.selectedAmortization.split(" ")[0];
      }
    }
  }

  getDate() {

    const futureDate = new Date();
    const date = futureDate;
    futureDate.setDate(futureDate.getDate() + 5);
    const currentDay = futureDate.getDate();
    const monthIndex = futureDate.getMonth();
    const currentYear = futureDate.getFullYear();
    const currentMonth = (this.currentLang == "en") ? this.month_en[monthIndex] : (this.currentLang == "fr") ? this.month_fr[monthIndex] : '';
    this.formatted = currentMonth + " " + currentDay + ", " + currentYear;
    this.switch_rate_expires = formatDate(date, 'yyyy-MM-dd HH:mm:ss', 'en-US');
    this.preQualObj.switch_rate_expires = this.switch_rate_expires;
  }
  setTimer() {
    const StartTime = new Date();
    const hrs = StartTime.getHours();
    const mins = StartTime.getMinutes();
    const sec = StartTime.getSeconds();
    const totalStartTime = (hrs * 3600) + (mins * 60) + sec;
    const timer = setInterval(() => {
      const curr_time = new Date();
      const curr_hr = curr_time.getHours();
      const curr_mins = curr_time.getMinutes();
      const curr_sec = curr_time.getSeconds();
      const totalCurrentTime = (curr_hr * 3600) + (curr_mins * 60) + (curr_sec);
      if (totalCurrentTime - totalStartTime >= 300) {
        if (this.timerCompleted) {
          return;
        }
        this.timerCompleted = true;
        this.timeFormat();
        if (this.preQualObj.flow_type == this.switchType) {
          this.AdobeTracking('confirmation?flow=switch');
        }
        if(totalCurrentTime - totalStartTime == 300){
        this.save();
        }
        clearInterval(timer);
        sessionStorage.setItem("startTimer for summaryPage", "false")
      }
    }, 1000)
  }
  openPopupFr() {
    var isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (isIos) {
      let tooltpBoxVal = document.getElementById("btnttltip1").getAttribute("aria-expanded");
      if (tooltpBoxVal == "false") {
        document.getElementById("btnttltip1").setAttribute('aria-expanded', 'true');
      }
      else {
        document.getElementById("btnttltip1").setAttribute('aria-expanded', 'false');
      }
    }
  }
  AdobeTracking(data) {
    let digitalData = this.adobeAnalyticsData.load(data)

    if (document.getElementById("adobe-tracking-digital-data")) {
      document.getElementById("adobe-tracking-digital-data").remove();
      let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalData + "; if(_satellite){ _satellite.track('track'); }</script>"
      $("head").append(element);
    }
  }
  openPopupEn() {
    var isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (isIos) {
      let tooltpBoxVal = document.getElementById("btnttltip").getAttribute("aria-expanded");
      if (tooltpBoxVal == "false") {
        document.getElementById("btnttltip").setAttribute('aria-expanded', 'true');
      }
      else {
        document.getElementById("btnttltip").setAttribute('aria-expanded', 'false');
      }
    }
  }
  tooltipExpandFalse() {
    var isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (isIos) {
      document.getElementById("btnttltip").setAttribute('aria-expanded', 'false');
      document.getElementById("btnttltip1").setAttribute('aria-expanded', 'false');
    }
  }
  closeTolltip() {
    this.tooltipExpandFalse();
    $('#btnttltip').focus()
  }

  closeTolltip1() {
    this.tooltipExpandFalse();
    $('#btnttltip1').focus();
  }
  submitWcall() {
    this.loader = true;
    const productBody = {
      "pdtDetails": [{
        "productId": String(this.prdDetails.productDetails.rates[0].rate[0].rateTypeID),
        "clientRate": this.prdDetails.productDetails.rates[0].rate[0].rateValue,
        "term": this.prdDetails.productDetails.metaData.term.toString(),
        "amortizationStart": 3,
        "amortizationEnd": 30
      }]
    }
    let users = { "users": this.preQualObj };
    const reqBody = { ...users, ...productBody };
      this.util.getSwitchDetails(reqBody, 'W').subscribe((res: any) => {
        this.loader = false;
        this.preQualObj.pdtDetails = res.pdtDetails;
        this.assignValues();
      }, (err) => {
        this.loader = false;
        console.log(err);
      }
      )
  }
  assignValues() {
    const amortIndex = this.prdDetails.productDetails.rates[0].rate.findIndex(obj => obj.rateValue == this.clientRate);


    if (amortIndex == 1) {
      const decimals = ((Number(this.preQualObj.switch_interest_rate.rate.split("%")[0]) - Number(this.preQualObj.switch_interest_rate.arp)) * 10) % 1 === 0 ? 1 : 2;
      this.preQualObj.switch_interest_rate.rate = (Number(this.preQualObj.switch_interest_rate.rate.split("%")[0]) - Number(this.preQualObj.switch_interest_rate.arp)).toFixed(decimals) + "%";
      this.discount = (Number(this.preQualObj.switch_interest_rate.discount.split("%")[0]) - Number(this.preQualObj.switch_interest_rate.arp)).toString();
      if (this.currentLang == this.currLangEn) {
        this.selectedAmortization = this.preQualObj.amortization_payments.selectedAmortization + " Years";
      }
      else if (this.currentLang == this.currLangFr) {
        this.selectedAmortization = this.preQualObj.amortization_payments.selectedAmortization + " années";
      }
    }
    else if (amortIndex == 0) {
      if (this.currentLang == this.currLangEn) {
        this.selectedAmortization = this.amortlower;
      }
      else if (this.currentLang == this.currLangFr) {
        this.selectedAmortization = this.amortHigher;
      }
    }



    this.selectedAmortizationPopUp = this.selectedAmortization.split(" ")[0];
    let prequalSelectedFreq = this.preQualObj?.amortization_payments?.selectedFrequency;
    if (this.currentLang == this.currLangEn)
      this.selectedFrequency = this.mappedPaymentFrequency.find(obj => (obj.code == prequalSelectedFreq) || (obj.en == prequalSelectedFreq)).en;
    else if (this.currentLang == this.currLangFr)
      this.selectedFrequency = this.mappedPaymentFrequency.find(obj => (obj.code == prequalSelectedFreq) || (obj.fr == prequalSelectedFreq)).fr;
    if (amortIndex == 1) {
      this.amortizationChangeValues = this.preQualObj.pdtDetails[0].mtgPandIAmtDetails.find(obj => obj.amortization === 30);
      this.estimatedPaymentsSwitch = this.preQualObj.pdtDetails[0].mtgPandIAmtDetails.find(obj => obj.amortization === 30).paymentDetails[0].prinAndintPaymentAmount;
    }
    else if (amortIndex == 0) {
      this.amortizationChangeValues = this.preQualObj.pdtDetails[0].mtgPandIAmtDetails.find(obj => obj.amortization === 25);
      this.estimatedPaymentsSwitch = this.preQualObj.pdtDetails[0].mtgPandIAmtDetails.find(obj => obj.amortization === 25).paymentDetails[0].prinAndintPaymentAmount;
    }
    this.estimatedPaymentsSwitch = this.estimatedPaymentsSwitch;
    const selectedAmortizationPayment = {
      "selectedAmortization": this.selectedAmortization.split(" ")[0],
      "selectedFrequency": this.selectedFrequency,
      "estimatedPaymentsSwitch": this.estimatedPaymentsSwitch
    }
    this.preQualObj.amortization_payments = selectedAmortizationPayment;
    this.preQualObj.encodedRequestPreQual = "";
    const prequalClone = { ...this.preQualObj };
    delete prequalClone.pdtDetails;
    this.util.setSessionStorage(prequalClone);
    this.saveJson(prequalClone);
  }
  setPopOver(type: string) {
    this.popOverType = type;
  }
  onAmortizationChange(val: any) {
    if (Number(val.match(/\d+/g)) > 25) {
      const decimals = ((Number(this.preQualObj.switch_interest_rate.rate.split("%")[0]) + Number(this.preQualObj.switch_interest_rate.arp)) * 10) % 1 === 0 ? 1 : 2;
      this.clientRate = (Number(this.preQualObj.switch_interest_rate.rate.split("%")[0]) + Number(this.preQualObj.switch_interest_rate.arp)).toFixed(decimals);
      this.discount = (Number(this.preQualObj.switch_interest_rate.discount.split("%")[0]) - Number(this.preQualObj.switch_interest_rate.arp)).toString();
    }
    else {
      this.clientRate = this.preQualObj.switch_interest_rate.rate.split("%")[0];
      this.discount = (this.preQualObj.switch_interest_rate.discount.split("%")[0]);
    }
    this.selectedAmortization = val;
    this.selectedAmortizationPopUp = this.selectedAmortization.split(" ")[0];
    val = Number(val.match(/\d+/g));
    this.amortizationChangeValues = this.preQualObj.pdtDetails[0].mtgPandIAmtDetails.find(obj => obj.amortization === val);
    if (this.currentLang == this.currLangFr) {
      this.estimatedPaymentsSwitch = this.amortizationChangeValues.paymentDetails.find(obj => obj.paymentFrequency === this.mappedPaymentFrequency.find(obj => obj.fr == this.selectedFrequency).en.charAt(0)).prinAndintPaymentAmount;
    }
    else if (this.currentLang == this.currLangEn){
      this.estimatedPaymentsSwitch = this.amortizationChangeValues.paymentDetails.find(obj => obj.paymentFrequency === this.selectedFrequency.charAt(0)).prinAndintPaymentAmount;
    }
    this.estimatedPaymentsSwitch = this.estimatedPaymentsSwitch;
    this.saveDetails();
  }
  onpaymentFreqChange(val: any) {
    this.selectedFrequency = val;
    if (this.currentLang == this.currLangFr)
      this.estimatedPaymentsSwitch = this.amortizationChangeValues.paymentDetails.find(obj => obj.paymentFrequency === this.mappedPaymentFrequency.find(obj => obj.fr == this.selectedFrequency).en.charAt(0)).prinAndintPaymentAmount;
    else if (this.currentLang == this.currLangEn) {
      this.estimatedPaymentsSwitch = this.amortizationChangeValues.paymentDetails.find(obj => obj.paymentFrequency === this.selectedFrequency.charAt(0)).prinAndintPaymentAmount;
    }
    this.estimatedPaymentsSwitch = this.estimatedPaymentsSwitch;
    this.saveDetails();
  }
  closeWindow() {
    window.close();
  }
  save() {
    this.saveDetails();
    delete this.preQualObj.pdtDetails;
    this.util.saveJson(this.preQualObj).subscribe(response => {
      this.util.getImportCustomerPortal(response).subscribe();
    }, (err) => {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
    );
  }
  timeFormat() {
    const currentTime = new Date();
    const date = currentTime.toLocaleDateString('en-US');
    const time = currentTime.toLocaleTimeString('en-US');
    this.timestamp = date + " " + time;
  }
  change(event: Event) {
    const target = event.target as HTMLInputElement;
    let index = Number(target.value) - 1;
    this.clicked = true;
    this.preQualObj.preQualify_purchase_price = this.mortgageAmounts[index].sliderHomePurchasePrice
    this.downPayment = this.mortgageAmounts[index].sliderDownpayment;
    this.mortgageAmount = this.mortgageAmounts[index].sliderTotalMtgAmt;
    this.netMortgageAmount = this.mortgageAmounts[index].sliderNetMtgAmt;
    this.insureFee = this.mortgageAmounts[index].sliderInsurerFee;
    this.estimatedPayments = this.mortgageAmounts[index].sliderPaymentAmt;
    this.mortgage_principal = this.mortgageAmounts[index].sliderNetMtgAmt;
    this.indexNumber = index;
    this.saveDetails();
  }
  saveJson(reqBody) {
    console.log(reqBody,"reqbody")
    this.util.saveJson(reqBody).subscribe(res => {
    }, () => {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
    )
  }
  saveDetails() {
    this.preQualObj.status = CONSTANTS.applicationConstants.pendingContact;
    if (this.preQualObj.flow_type == this.prequalType) {
      this.thumbColor = true;
      this.preQualObj.prequal_slider.forEach(obj => obj.sliderStatus = false);
      const index = this.preQualObj.prequal_slider.findIndex(sliderValue => this.downPayment == sliderValue.sliderDownpayment);
      if (index >= 0) {
        this.preQualObj.prequal_slider[index].sliderStatus = true;
        this.preQualObj.prequal_slider[index].updatedTime = "";
      }
      var prequal_clone = _.cloneDeep(this.preQualObj);
    }
    else if (this.preQualObj.flow_type == this.switchType) {
      const selectedAmortizationPayment = {
        "selectedAmortization": this.selectedAmortization.split(" ")[0],
        "selectedFrequency": this.selectedFrequency,
        "estimatedPaymentsSwitch": this.estimatedPaymentsSwitch
      }
      this.preQualObj.amortization_payments = selectedAmortizationPayment;
      this.preQualObj.encodedRequestPreQual = "";
      var prequal_clone = _.cloneDeep(this.preQualObj);
      delete prequal_clone?.pdtDetails;
    }
    this.util.setSessionStorage(prequal_clone);
  }

}
